export const INITIAL_SIZE = 64;
export const EXPANDED_SIZE = 200;

export const autoHeightVariant = {

  false: {
    height: 0,
  },
  true: {
    height: 'auto',
  },

};

export const increaseWidthVariant = {
  short: {
    width: INITIAL_SIZE,
  },
  full: {
    width: EXPANDED_SIZE,
  },
};

export const addWidthVariant = {
  short: {
    width: 0,
  },
  full: {
    width: EXPANDED_SIZE,
  },
};

export const rotateY180Variant = {
  short: {
    rotateY: '0deg',
  },
  full: {
    rotateY: '180deg',
  },
};

export const rotateX180Variant = {
  short: {
    rotateX: '0deg',
  },
  full: {
    rotateX: '180deg',
  },
};
